<template>
    <div id="question-zone">
        <div id="number-question">
            Question 3/3
        </div>
        <div id="question">
            <h2>Choisissez trois approches thérapeutiques et glissez-les dans le tableau : </h2>
            <div id="drag-zone-q3">
                <draggable v-model="list" class="drag-area" id="area-choice"
                           :options="{group:'approach',disabled : validationQ3}">

                    <div class="element" :key="element.name" v-for="element in list">{{element.name}}</div>


                </draggable>
                <draggable v-model="list2" class="drag-area" id="area-result"
                           :options="{group:'approach', disabled : validationQ3}">

                    <div class="element-bg" :key="element.name" v-for="element in list2">
                        <div class="element">{{element.name}}</div>
                    </div>
                </draggable>

            </div>
            <div id="result">
                <div>
                    <span id="message" v-show="validationQ3">
                        texte
                    </span>
                </div>
                <transition name="button-transition" leave-active-class="animated fadeOutDown"
                            enter-active-class="animated fadeInUp" mode="out-in">
                    <button @click="emitNextQ" key="Valid" v-if="validationQ3">
                        Suivant →
                    </button>
                    <button @click="validationQ3M" :disabled="list2.length < 3" key="NoValid" v-else>
                        Validez →
                    </button>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
    import draggable from 'vuedraggable'

    export default {
        name: 'Question3',
        data() {
            return {
                validationQ3: false,
                list: [
                    {
                        name: "Thérapie de reconstitution immunitaire sélective"
                    },
                    {
                        name: "Thérapie de reconstitution immunitaire non-sélective"
                    },
                    {
                        name: "Immunosuppression continue"
                    },
                    {
                        name: "Thérapie cellulaire"
                    },
                    {
                        name: "Immunomodulation continue"
                    },
                    {
                        name: "Thérapie de reconstitution immunitaire"
                    }
                ],
                list2: [],
                model: ["Immunomodulation continue", "Immunosuppression continue", "Thérapie de reconstitution immunitaire"]

            }
        },
        methods: {
            validationQ3M: function () {
                $('.element-bg .element').text();
                this.verifAnswer = this.list2.map(element => Object.values(element).toString());
                this.verifAnswer.sort();
                if (JSON.stringify(this.verifAnswer) === JSON.stringify(this.model)) {
                    $('#message').addClass('true').text("Ceci est la bonne réponse")
                    this.validationQ3 = true
                    $('.element-bg .element').css({"background-color": "#9bf2c4", "border-color": "#24ce74"})
                } else {
                    $('#message').addClass('false').text("Ceci est la mauvaise réponse")
                    this.validationQ3 = true
                    $('.element-bg .element').css({"background-color": "#fcccd4", "border-color": "#ce4259"})
                    $(".drag-area").find(".element:contains('Thérapie de reconstitution immunitaire sélective')").css({
                        "background-color": "#9bf2c4",
                        "border-color": "#24ce74"
                    })
                    $(".drag-area").find(".element:contains('Immunosuppression continue')").css({
                        "background-color": "#9bf2c4",
                        "border-color": "#24ce74"
                    })
                    $(".drag-area").find(".element:contains('Immunomodulation continue')").css({
                        "background-color": "#9bf2c4",
                        "border-color": "#24ce74"
                    })

                }
            },
            emitNextQ() {
                this.$emit('next')
            }
        },
        components: {
            draggable
        },
        watch: {
            list2() {
                console.log("list2 = " + this.list2.length)
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/css/default";

    #drag-zone-q3 {
        display: flex;
        align-items: center;
        justify-content: center;
        .drag-area {
            min-height: 50px;
            margin: 50px;
            min-width: 30%;

            .element {
                box-shadow: 5px 3px 3px rgba(0, 0, 0, 0.2);
                border: 2px solid #dfdfdf;
                background-color: #fff;
                margin: 20px;
                padding: 5px 20px;
                cursor: move;
            }
            &#area-choice {
                transition: 200ms;
                &:hover {
                    background-color: #6f7ece;
                }
            }
            &#area-result {

                border: 1px solid #a5a5a5;
                transition: 200ms;
                &:hover {
                    background-color: #6f7ece;
                }
                .element-bg {
                    padding: 30px;

                    &:nth-child(odd) {
                        background-color: #e4e4e4;
                    }
                    &:nth-child(even) {
                        background-color: #f7f7f7;
                    }

                }
            }

        }

    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

</style>